/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

import Section from 'bundles/front-page/components/Section';
import AiPromptPillsContainer from 'bundles/front-page/redesign-modules/ai-search/AiPromptPillsContainer';
import SearchBar from 'bundles/search-common/components/searchbar/SearchBar';
import { SEARCH_BAR_LOCATION } from 'bundles/search-common/constants';
import { useAiSearchExperimentData } from 'bundles/search-common/providers/AiSearchExperimentProvider';
import LavaLampGradientBackground from 'bundles/unified-common/components/coach-on-discovery/LavaLampGradientBackground';

import _t from 'i18n!nls/front-page';

const styles = {
  section: css`
    position: relative;
    margin-top: calc(var(--cds-spacing-200) * -1);
    padding-bottom: var(--cds-spacing-400);

    ${breakpoints.down('sm')} {
      padding-bottom: var(--cds-spacing-200);
    }
  `,
  content: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: var(--cds-spacing-200);
    gap: var(--cds-spacing-200);

    ${breakpoints.down('xs')} {
      gap: var(--cds-spacing-200);
    }
  `,
  title: css`
    ${breakpoints.down('xs')} {
      display: none;
    }
  `,
  searchBarWrapper: css`
    width: 100%;
    max-width: 614px;
    padding-bottom: var(--cds-spacing-150);

    .cds-Search-base {
      max-width: unset !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    ${breakpoints.down('xs')} {
      padding-bottom: var(--cds-spacing-50);
    }
  `,
};

const AiSearchModuleRenderer = () => {
  const { isVariant2 } = useAiSearchExperimentData();

  if (!isVariant2) return null;

  return (
    <Section css={styles.section}>
      <LavaLampGradientBackground />
      <div css={styles.content}>
        <Typography2 variant="titleXSmall" component="h2" align="center" css={styles.title}>
          {_t('What do you want to learn?')}
        </Typography2>
        <div css={styles.searchBarWrapper}>
          <SearchBar pageLocation={SEARCH_BAR_LOCATION.FrontPage} />
        </div>
      </div>
      <AiPromptPillsContainer />
    </Section>
  );
};

export default AiSearchModuleRenderer;
